import styled from "styled-components";

export const TitleH1 = styled.h1`
  text-align: center;
  font-size: 54px;
  font-weight: 600;
  position: relative;
  margin-bottom: 10px;
`;

export const SpanDescription = styled.strong`
  font-size: 22px;
  font-weight: 300;
`;

export const FooterFixed = styled.div`
   width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 80px;
`;
